import type { ICredentialingReqAggregation } from '$shared/interfaces/api/ICredentialingReqAggregation';
import BaseModel from '$shared/models/BaseModel';

export class CvoAggregation extends BaseModel<ICredentialingReqAggregation> {
  public get all(): number {
    const totalCount = [
      this.response.aggregations.requestSubmitted,
      this.response.aggregations.requestInProgress,
      this.response.aggregations.additionalInformationRequested,
      this.response.aggregations.secondAttemptMissingInfo,
      this.response.aggregations.thirdAttemptMissingInfo,
      this.response.aggregations.additionalInformationSubmitted,
      this.response.aggregations.cancellationRequested
    ].sum();
    return this.getValidCount(totalCount);
  }

  public get cancellationRequest(): number {
    return this.getValidCount(this.response.aggregations.cancellationRequested);
  }

  public get needsAdditionalInfo(): number {
    const reviewCount: number = [
      this.response.aggregations.additionalInformationRequested,
      this.response.aggregations.secondAttemptMissingInfo,
      this.response.aggregations.thirdAttemptMissingInfo
    ].sum();
    return this.getValidCount(reviewCount);
  }

  private getValidCount(count: number): number {
    return (!isNaN(count) && count) || 0;
  }

  static create(response: ICredentialingReqAggregation): CvoAggregation {
    return new CvoAggregation(response);
  }
}
